import { initClarity } from '@app/analytics/clarity.hook'
import { initAmplitude } from '@app/analytics/amplitude'

export default defineNuxtRouteMiddleware(() => {
  initAmplitude()
  initClarity()
})
